import React, { useState, useEffect, Fragment, useContext } from "react";
import { UrlServicesContext } from "components/UrlServicesContext";
import { Redirect } from "react-router-dom";

import { makeStyles } from "@mui/styles";
// core components
import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";
import { PersonOutline, Add, Cancel } from "@mui/icons-material";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import clsx from "clsx";
import { DataGrid, GridActionsCellItem } from "@mui/x-data-grid";
import Moment from "moment";
import {
  Grid,
  Box,
  DialogContent,
  DialogActions,
  Dialog,
  Tooltip,
  Alert,
} from "@mui/material";
import axios from "axios";

import NewDependentsAdmin from "views/dialog/NewDependentsAdmin";

import loaderGif from "assets/img/loading.gif";
import noDataImg from "assets/img/undraw_House_searching_re_stk8.png";

import {
  cardBodyStyle,
  ButtonStyle0,
  ButtonExit,
} from "assets/jss/material-dashboard-react/components/cardBodyStyle";

const useStyles = makeStyles(cardBodyStyle);

export default function ViewsDependentsAdmin(props) {
  const classes = useStyles();

  const [rows, setRows] = useState([]);
  const [idClient, setIdClient] = useState("");
  const [loader, setLoader] = useState(true);
  const [newDependents, setNewDependents] = useState(false);
  const [idRow, setIdRow] = useState("");
  const [loaderSave, setLoaderSave] = useState(false);
  const [openModal, setOpenModal] = useState(false); // State for modal visibility
  const [error, setError] = useState(false);
  const [mensageSystem, setMensageSystem] = useState("");
  const [success, setSuccess] = useState(false);
  const [returnLogin, setReturnLogin] = React.useState(false);

  const { urlServices, UserAuth } = useContext(UrlServicesContext);

  let keyAuthorization = UserAuth.Session;

  const [state] = useState({
    columns: [
      {
        headerName: "Nombre y Apellido",
        field: "allNames",
        flex: 1,
        // headerAlign: "center",
        headerClassName: "super-app-theme--header",
        cellClassName: (params) => {
          return clsx("super-app", {
            celAll: params.value,
          });
        },
        sortable: false,
        hideable: false,
      },
      {
        headerName: "Documento",
        field: "documentIdDependent",
        width: 120,
        // headerAlign: "center",
        headerClassName: "super-app-theme--header",
        cellClassName: (params) => {
          return clsx("super-app", {
            celAll: params.value,
          });
        },
        sortable: false,
        hideable: false,
      },
      {
        headerName: "Tipo persona",
        field: "typePersonName",
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        renderCell: (params) => {
          return <b style={{ fontSize: 12 }}>{params.value}</b>;
        },
        cellClassName: (params) => {
          return clsx("super-app", {
            wordWrap: params.value,
          });
        },
        align: "center",
        width: 120,
        sortable: false,
        filtering: false,
        hideable: false,
      },
      {
        headerName: "Fecha nacimiento",
        field: "dateBirthDependent",
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        renderCell: (params) => {
          return <span>{Moment(params.value).format("DD-MM-YYYY")} </span>;
        },
        cellClassName: (params) => {
          return clsx("super-app", {
            celAll: params.value,
          });
        },
        align: "center",
        width: 140,
        sortable: false,
        filtering: false,
        hideable: false,
      },
      {
        headerName: "-----",
        field: "actions",
        type: "actions",
        width: 80,
        headerClassName: "super-app-theme--header",
        cellClassName: (params) => {
          return clsx("super-app", {
            celActions: params.value,
          });
        },
        getActions: (params) => {
          const actions = [];
          // Si el perfil está habilitado, mostramos el icono para deshabilitarlo
          actions.push(
            <GridActionsCellItem
              key="disable"
              icon={
                <Tooltip title="Eliminar" arrow>
                  <Cancel style={{ fontSize: 24, color: "#000" }} />
                </Tooltip>
              }
              label="Eliminar"
              onClick={openStatusValue(params)}
            />
          );

          return actions;
        },
      },
    ],
  });

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
    RefreshTable(0);
  }, []);

  const RefreshTable = (n, data = null) => {
    if (n !== 0) {
      props.callBackRefresh();
      setRows(data);
    } else {
      const dataFinal = props.id.row.dependents.filter(
        (val) => val.status === 1
      );
      setRows(dataFinal);
    }

    setIdClient(props.id.row.id);
    setLoader(false);
  };

  const submitSave = async () => {
    setError(false);
    setLoaderSave(true);

    const dataNew = props.id.row.dependents.map((val) => {
      if (val.id === idRow.id) {
        // Devuelve un nuevo objeto con el status actualizado
        return { ...val, status: 0 };
      }
      // Devuelve el objeto sin cambios
      return val;
    });

    const data = {
      dependents: JSON.stringify(dataNew),
    };

    try {
      const response = await axios.put(
        `${urlServices}clients/${props.id.row.id}`,
        data,
        {
          headers: {
            Authorization: "Bearer " + keyAuthorization,
          },
        }
      );

      if (response.status === 200) {
        const dataFinal = dataNew.filter((val) => val.status === 1);
        setRows(dataFinal);
        setSuccess(true);
        setLoaderSave(false);
        props.callBackRefresh();
      }
    } catch (error) {
      if (error.response?.status === 401) {
        setMensageSystem("La sesión ha expirado, vuelva a iniciar sesión ...");
        setError(true);
        setTimeout(() => {
          localStorage.clear();
          setReturnLogin(true);
        }, 4000);
      } else if (error.response?.status === 500) {
        setMensageSystem("Error en la consulta con el servidor.");
        setError(true);
      } else {
        console.error("Error en la solicitud:", error);
        setMensageSystem("Error al realizar la solicitud.");
        setError(true);
      }

      setLoaderSave(false);
    }
  };

  const handleCloseDialog = (pro) => (event) => {
    props.exit();
  };

  const handleNewDependents = () => () => {
    setNewDependents(true);
  };

  const openStatusValue = (data) => () => {
    setIdRow(data.row);
    setSuccess(false);
    setLoaderSave(false);
    setOpenModal(true);
  };

  // Function to close the modal
  const handleCloseModal = () => {
    setOpenModal(false); // Close the modal
  };

  const handleCloseNewDependents = () => setNewDependents(false);

  if (returnLogin) {
    return <Redirect to="/" />;
  }

  return (
    <Fragment>
      <Dialog
        fullWidth
        maxWidth="md"
        onClose={handleCloseDialog(true)}
        aria-labelledby="customized-dialog-title"
        open={props.open}
        keepMounted
        scroll="body"
        // style={{ zIndex: 100 }}
        PaperProps={{
          sx: {
            borderRadius: 6,
          },
        }}
      >
        <DialogContent dividers className={classes.styleDialogContent}>
          <GridContainer>
            <GridItem xs={12} sm={12} md={12}>
              <div className={classes.cardTitleBlack}>
                <PersonOutline className={classes.iconFilter} /> Listado de
                familiares del cliente
              </div>
              <Card>
                <CardBody>
                  {loader ? (
                    <Grid container spacing={2}>
                      <Grid item xs={12} sm={12}>
                        <center>
                          <img
                            alt="loaderGif"
                            src={loaderGif}
                            style={{ width: 60, margin: "20% 0" }}
                          />
                        </center>
                      </Grid>
                    </Grid>
                  ) : (
                    <Fragment>
                      <Grid container>
                        <Grid item xs={12} sm={12}>
                          <div style={{ float: "right" }}>
                            <ButtonStyle0
                              onClick={handleNewDependents()}
                              endIcon={<Add />}
                            >
                              Nuevo registro
                            </ButtonStyle0>
                          </div>
                        </Grid>
                        {rows.length > 0 ? (
                          <Grid item xs={12} sm={12}>
                            <Box
                              sx={{
                                "& .super-app.celAll": {
                                  fontSize: 12,
                                  //backgroundColor: 'rgba(255, 7, 0, 0.55)',
                                },
                                "& .super-app.celActions": {
                                  backgroundColor: "rgb(242, 242, 242)",
                                },
                                "& .super-app-theme--header": {
                                  backgroundColor: "rgb(242, 242, 242)",
                                },
                                "& .super-app.wordWrap": {
                                  fontSize: 10,
                                  textAlign: "center",
                                },
                                marginTop: 2,
                              }}
                            >
                              <DataGrid
                                rows={rows}
                                columns={state.columns}
                                loading={loader}
                                initialState={{
                                  pagination: {
                                    paginationModel: { page: 0, pageSize: 10 },
                                  },
                                }}
                                pageSizeOptions={[5, 10, 20, 50]}
                                disableRowSelectionOnClick={true}
                                checkboxSelection={false}
                                //rowHeight={40}
                                autoHeights
                              />
                            </Box>
                          </Grid>
                        ) : (
                          <Grid item xs={12} sm={12}>
                            <center>
                              <img
                                alt="loaderGif"
                                src={noDataImg}
                                style={{ width: 200, marginTop: 50 }}
                              />
                              <br></br>
                              <b
                                style={{ fontSize: 16, margin: "5px 0 70px 0" }}
                              >
                                No hay registros para mostrar
                              </b>
                            </center>
                          </Grid>
                        )}
                      </Grid>
                    </Fragment>
                  )}
                </CardBody>
              </Card>
            </GridItem>
          </GridContainer>
        </DialogContent>
        <DialogActions>
          <ButtonExit onClick={handleCloseDialog(true)}>Cerrar</ButtonExit>
        </DialogActions>
      </Dialog>
      {/* Modal */}
      <Dialog
        open={openModal}
        onClose={handleCloseModal}
        maxWidth="xs"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: 6,
          },
        }}
      >
        <DialogContent>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={12}>
              {error && <Alert severity="error">{mensageSystem}</Alert>}
              <center>
                <div
                  className={classes.titleCardFilter}
                  style={{ marginTop: 20 }}
                >
                  ¿Desea eliminar este familiar?
                </div>
              </center>
            </Grid>
            <Grid item xs={12} sm={12} sx={{ pt: 1 }}>
              <center>
                <ButtonStyle0
                  onClick={submitSave}
                  disabled={loaderSave || success}
                >
                  {" "}
                  {loaderSave ? "En proceso..." : "Eliminar"}
                </ButtonStyle0>
              </center>
              {success && <Alert severity="success">Familiar eliminado</Alert>}
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <ButtonExit onClick={handleCloseModal}>Cerrar</ButtonExit>
        </DialogActions>
      </Dialog>
      {newDependents && (
        <NewDependentsAdmin
          open={newDependents}
          exit={handleCloseNewDependents}
          callBackRefresh={RefreshTable}
          row={rows}
          idClient={idClient}
        />
      )}
    </Fragment>
  );
}
